const articleTitles = Array.from(document.querySelectorAll(".article__title"));
const articleRow = Array.from([]);

let maxHeight = 0;
let rowTitles = [];

articleTitles.forEach((title, index) => {
  if (index > 0 && index % 3 == 0) {
    maxHeight = 0;
    rowTitles = []
  }

  if (title.clientHeight > maxHeight) {
    maxHeight = title.clientHeight;
  }
  rowTitles.push(title)


  if (index == articleTitles.length - 1 || index % 3 == 2) {
    articleRow.push({
      maxHeight: maxHeight,
      titles: rowTitles
    })
  }
})


articleRow.forEach(row => {
  row.titles.forEach(column => {
    column.style.height = `${row.maxHeight}px`;
  })
});
